import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { Styled } from '../types';
import FeatherIcon from './Icon/FeatherIcon';

export type NoticeData = {
  title?: string;
  message: string;
  icon?: string;
  bgcolor?: string;
  titlecolor?: string;
  textcolor?: string;
};

type NoticeProps = Styled & NoticeData;

const Notice = ({
  message,
  title = '',
  className = '',
  style = {},
  icon = '',
  ...notice
}: NoticeProps) => {
  const [visible, setVisible] = useState(true);
  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);
  if (!visible) {
    return null;
  }
  return (
    <div
      className={classNames(
        'flex p-4 rounded-t rounded-br mb-6 flex-shrink-0',
        className
      )}
      style={{ backgroundColor: notice.bgcolor || 'white', ...style }}
    >
      <div className="flex flex-col flex-1">
        {title && (
          <span
            className="font-body md:text-lg opacity-75"
            style={{ color: notice.titlecolor || style.color || 'black' }}
          >
            {title}
          </span>
        )}
        <span
          className="font-body text-xs md:text-sm"
          style={{ color: notice.textcolor || style.color || 'black' }}
        >
          {message}
        </span>
      </div>
      <div className="ml-2 md:ml-4 mt-1">
        <button type="button" onClick={handleClose}>
          <FeatherIcon name="x" size={24} />
        </button>
      </div>
    </div>
  );
};

export default Notice;
